<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <h4 slot="header" class="card-title">
            Usuários
            <TotalRegisters :total="usersTableData.total" totalText="usuários cadastrados" />
          </h4>
          <Table :tableData="usersTableData" :data="users" :columns="['id', 'name', 'email', 'active', 'actions']" :actions="['view']" @openDetailsModal="openDetailsModal" @pagechanged="onPageChange" :expandable="true">
            <template slot="expandBox" slot-scope="props">
              <div class="mt-2">Informações adicionais</div>
              <div v-for="(dt, i) in props.dt.response" :key="i">
                <label>{{ dt.profileType }}: {{ dt.profileResponse }}</label>
              </div>
            </template>
          </Table>

          <ListLoader v-if="usersTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!usersTableData.loading && usersTableData.error"></Error>
          <Empty v-if="!usersTableData.loading && !usersTableData.error && users.length === 0"></Empty>
        </card>
      </div>
    </div>

    <Modal v-model="visibilityStates.readVisibility" action="Ok" title="Detalhes do usuário" @closeModal="visibilityStates.readVisibility = false" @confirmAction="visibilityStates.readVisibility = false">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" class="form-control" :placeholder="user.name" disabled />
        </div>

        <div class="form-group">
          <label>E-mail</label>
          <input type="text" class="form-control" :placeholder="user.email" disabled />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Empty from '@/components/Common/Empty';
import Modal from '@/components/Modal/Modal';
import Search from '@/components/Common/Search';
import Table from '@/components/Common/Table';
import TotalRegisters from '@/components/Common/TotalRegisters';

export default {
  components: {
    Empty,
    Modal,
    Search,
    Table,
    TotalRegisters,
  },
  data() {
    return {
      visibilityStates: {
        readVisibility: false,
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters['users/getUsers'];
    },
    usersTableData() {
      return this.$store.getters['users/getUsersTableData'];
    },
    user() {
      return this.$store.getters['users/getUser'];
    },
  },
  methods: {
    doSearch: async function(search) {
      this.$store.dispatch('users/searchUser', search);
    },
    openDetailsModal: async function(id) {
      await this.$store.dispatch('users/getUserById', id);
      this.visibilityStates.readVisibility = true;
    },
    onPageChange(page) {
      this.$store.dispatch('users/setPage', page);
    },
  },
  mounted() {
    this.$store.dispatch('users/resetPagination');
  },
};
</script>
